import React from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { IoMdClose as CloseIcon } from 'react-icons/io'
import { Row, Container, Image, Button } from 'react-bootstrap'
import times from 'lodash/times'
// import get from 'lodash/get'
import { i18nTranslate } from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import { catalogContainer } from 'src/models'
import { productCompareState } from './state'
import './styles.scss'

@observer
class ProductCompareFloatingBar extends React.Component {
  nameSpace = 'ssr-resource'
  handleClose = product => {
    const index = catalogContainer.productCompareList.findIndex(
      item => item.productId === product.productId
    )
    catalogContainer.productCompareList.splice(index, 1)
  }

  renderProductImages = index => {
    const productsLength = (catalogContainer?.productCompareList || []).length
    if (productsLength > index) {
      const product = catalogContainer.productCompareList[index]
      const { imageURL } = product
      return (
        <div
          className="position-relative mr-5 image-wrapper d-flex justify-content-center align-items-center"
          key={`renderProductImages-${index}`}>
          <Image fluid src={imageURL} className="image mw-100 mh-100" />
          <CloseIcon
            size="1.5rem"
            className="product-close-icon"
            onClick={() => {
              this.handleClose(product)
            }}
          />
        </div>
      )
    } else {
      return (
        <div
          className="image-wrapper border mr-5"
          key={`renderProductImages-${index}`}
        />
      )
    }
  }

  renderFloatingText = () => {
    const compareText = i18nTranslate('product.compare', 'Compare', {
      nameSpace: this.nameSpace,
    })
    return (
      <div
        className={`compare-text-floating fixed-bottom px-4 py-2 bg-primary mr-3 mb-3 text-white`}
        onClick={() => {
          productCompareState.setFloatingBarState(true)
        }}>
        {compareText}{' '}
        <span>
          {catalogContainer.productCompareList.length}{' '}
          {i18nTranslate('product.items', 'Items', {
            nameSpace: this.nameSpace,
          })}
        </span>
      </div>
    )
  }

  render() {
    const isProductsAvailable = catalogContainer.productCompareList.length > 0
    const className = isProductsAvailable ? 'd-block' : 'd-none'
    const compareText = i18nTranslate('product.compare', 'Compare', {
      nameSpace: this.nameSpace,
    })

    if (productCompareState.showFloatingbar === false && isProductsAvailable) {
      return this.renderFloatingText()
    }

    const productIds = catalogContainer.productCompareList.reduce(
      (accumulator, current) => {
        const productId = current.productId
        return accumulator === '' ? productId : `${accumulator},${productId}`
      },
      ''
    )
    const pageLink = `${pageNames.productCompare}?productids=${productIds}`
    const enableCompareButton = catalogContainer.productCompareList.length < 2
    return (
      <div
        className={`fixed-bottom w-100 border-top border-primary p-4 product-compare-bar bg-white ${className}`}>
        <CloseIcon
          size="2rem"
          className="compare-close-icon"
          onClick={() => {
            productCompareState.setFloatingBarState(false)
          }}
        />
        <Container className="d-flex flex-wrap flex-column flex-sm-row">
          <div className="flex-grow-1 d-flex compare-product-wrapper justify-content-center">
            {times(
              catalogContainer.productCompareLimit,
              this.renderProductImages
            )}
          </div>
          <Row className="flex-column justify-content-center" noGutters>
            <Button
              variant="primary"
              className={`rounded-pill mb-3 px-4 ${
                enableCompareButton ? 'disable-button' : ''
              }`}
              disabled={enableCompareButton}>
              <Link to={pageLink} className="text-white">
                {compareText}
              </Link>
            </Button>
            <Button
              variant="outline-primary"
              className="rounded-pill px-4"
              onClick={() => {
                catalogContainer.productCompareList = []
              }}>
              {i18nTranslate('product.removeAll', 'Remove All', {
                nameSpace: this.nameSpace,
              })}
            </Button>
          </Row>
        </Container>
      </div>
    )
  }
}

export { ProductCompareFloatingBar }
